// Dependencies
import React, { Component, PropTypes } from 'react';

class SignInError extends Component {

  render() {
    const signinErrorClasses = 'inline-error opacity signin-alert';
    let style;
    if (this.props.signinInfo) {
      style = {
        backgroundColor: 'aliceblue',
        color: '#00BCD3',
      };
    }
    if (!this.props.signinError && !this.props.signinInfo) return false;
    return (
      <div style={{ marginTop: '8px' }}>
        <p className={signinErrorClasses} style={style}>
          {this.props.signinError || this.props.signinInfo}
        </p>
      </div>
    );
  }

}

SignInError.propTypes = {
  signinInfo: PropTypes.string,
  signinError: PropTypes.string,
};

export default SignInError;

/* jshint ignore:end */



// WEBPACK FOOTER //
// ./src/app/components/signin/signin-error.jsx